var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotLinked = function SvgNotLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.124 7.307c-.39 0-.699.3-.699.678 0 .387.31.696.699.696h3.678L5.427 7.307zM7.312 7.307 8.686 8.68h1.097v1.18c0 .608.592.828 1.079.458l2.467-1.85a.57.57 0 0 0 0-.933l-2.467-1.86c-.469-.351-1.08-.167-1.08.459v1.172z"
  })));
};
export default SvgNotLinked;